import {toggleMenu} from './togglemenu'

var hamburger = document.querySelector('.hamburger');
hamburger.addEventListener('click', toggleMenu);

//Add arrow if item has a submenu
document.querySelectorAll('.navigation > ul > li').forEach(function (element) {
    if (element.querySelector('.submenu')) {
        var clickableArrow = document.createElement('span');
        clickableArrow.setAttribute('class', 'icon-submenu')

        clickableArrow.addEventListener('click', function (e) {
            e.preventDefault();
            element.classList.toggle('sub-open');
            document.querySelector('.submenu:not(.megamenu-column)').classList.toggle('sub-open');
            hamburger.classList.toggle('hamburger--sub-open');
        });
        element.append(clickableArrow);
    }
});

//Add arrow if item has a megamenu
document.querySelectorAll('.navigation ul.submenu.megamenu li.megamenu-column').forEach(function (element) {
    if (element.querySelector('.megamenu-column__list')) {
        var clickableArrow = document.createElement('span');

        clickableArrow.addEventListener('click', function (e) {
            e.preventDefault();
            element.classList.toggle('sub-open');
            document.querySelector('.submenu').classList.toggle('sub-open');
        });
        element.append(clickableArrow);
    }
});

//Hide topmenu on scroll
var headerElement = document.querySelector('.header');
var anchorElement = document.querySelector('.block_anchor .inner');
var c, currentScrollTop = 0;

export function menuScroll() {
    var a = window.pageYOffset;
    var headerHeight = headerElement.offsetHeight;

    currentScrollTop = a;

    if (c < currentScrollTop && a > headerHeight + headerHeight) {
        headerElement.classList.add('isScrolled');
        headerElement.classList.remove('isTop');
        if (anchorElement){
            anchorElement.classList.add('isScrolled');
        }
    } else if (c > currentScrollTop && !(a <= headerHeight)) {
        headerElement.classList.remove('isScrolled');
        if (anchorElement){
            anchorElement.classList.remove('isScrolled');
        }
    } else {
        headerElement.classList.add('isTop');
    }
    c = currentScrollTop;
}
